import * as Sentry from '@sentry/react'

if (import.meta.env.PROD)
	Sentry.init({
		dsn: 'https://71b368a36e218073439782397142a460@o4508717261914112.ingest.de.sentry.io/4508739945365584',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration()
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ['hillaryclient.rizz.zone'],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	})

// import { scan } from 'react-scan'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { init, postEvent, retrieveLaunchParams } from '@telegram-apps/sdk-react'
import App from './App.tsx'
import './styles/styles.css'
import MiniAppRuntimeFailure from './error_screens/MiniAppRuntimeFailure/MiniAppRuntimeFailure.tsx'
import OutdatedClientError from './error_screens/OutdatedClientError/OutdatedClientError.tsx'

if (import.meta.env.DEV) {
	const { default: eruda } = await import('eruda')
	eruda.init()
}

const MIN_API_VERSION = '8.0'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// Check for potential client issues. Specifically:
// - Is it running in a Telegram client?
// - Is the client version outdated?
// Authorisation will be handled on the loading screen instead of here.

let RootObject,
	allowTelegramCalls = true
try {
	init()
	const launchParams = retrieveLaunchParams()
	console.log(JSON.stringify(launchParams))
	const { version } = launchParams
	if (version < MIN_API_VERSION) {
		RootObject = <OutdatedClientError requiredVersion={MIN_API_VERSION} />
	}
} catch {
	RootObject = <MiniAppRuntimeFailure />
	allowTelegramCalls = false
}

if (!RootObject) RootObject = <App />

if (allowTelegramCalls) {
	postEvent('web_app_set_background_color', { color: '#581c87' })
	postEvent('web_app_set_header_color', { color: '#581c87' })
}

root.render(<React.StrictMode>{RootObject}</React.StrictMode>)
